import Cookies from 'js-cookie'

import type { FlagConfigs, Project } from '@square/feature-relay-web-sdk'
import { createFeatureRelayClient, TokenType } from '@square/feature-relay-web-sdk'

export const flags: FlagConfigs = {
  // exampleFlag: createStringFlag({
  //   key: 'cash-web-help-center-example-flag',
  //   defaultValue: 'default-value',
  // }),
}

/**
 * Client for reading feature flags from LaunchDarkly
 * In development, uses default values defined in this file, set offlineMode to false to read from LaunchDarkly
 *
 * Usage:
 *  const { client, isLoading, error } = useFeatureFlagsContext()
 *  client.getFlagValue(flags['key'])
 */
export const getClient = () => {
  if (typeof window !== 'undefined') {
    const analyticsTrackingId = Cookies.get('__atidHelp')

    return createFeatureRelayClient({
      project: 'CASH' as Project, // TODO cameronandrews change to Project.CASH when proto updated https://prototype.stage.sqprod.co/#/docs/squareup.feature.relay.flags.message.LaunchDarklyProject
      flagConfigs: flags,
      origin: process.env.NEXT_PUBLIC_SQUAREUP_URL || 'https://squareupstaging.com',
      userToken: analyticsTrackingId
        ? { token: analyticsTrackingId, type: TokenType.DEVICE_ID }
        : { token: 'cash-web-experiment-default', type: TokenType.ANONYMOUS_VISITOR },
      offlineMode: process.env.NODE_ENV === 'development',
    })
  }

  return undefined
}
